import React, { useState } from "react";
import { API_BASE } from "../api";
import "./AdminLogin.css";

const AdminLogin = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(`${API_BASE}/api/auth/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username, password }),
            });

            const data = await response.json();

            if (response.ok) {
                localStorage.setItem("token", data.token);
                window.location.href = "/#/admin/dashboard";
            } else {
                alert(`Login Failed: ${data.message || "Invalid credentials"}`);
            }
        } catch (error) {
            alert("Connection error: Could not reach the server.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page-container">
            {/* Decorative elements */}
            <div className="login-decoration" style={{ top: '10%', left: '10%', width: '100px', height: '100px', background: 'rgba(79, 70, 229, 0.1)', borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%' }}></div>
            <div className="login-decoration" style={{ bottom: '15%', right: '12%', width: '150px', height: '150px', background: 'rgba(244, 63, 94, 0.1)', borderRadius: '64% 36% 27% 73% / 55% 58% 42% 45%' }}></div>

            <div className="login-main-card">
                <img 
                    src="./images/LEARNORAMA-LOGO.png" 
                    alt="Learnorama Logo" 
                    className="login-brand-logo" 
                />
                
                <div className="login-header-group">
                    <h2>Admin Portal</h2>
                    <p>Enter your credentials to manage Learnorama</p>
                </div>

                <div className="login-form-wrapper">
                    <form onSubmit={handleLogin} style={{width:'100%'}}>
                        <div className="login-input-field-group">
                            <input
                                type="text"
                                placeholder="Username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                autoComplete="username"
                            />
                        </div>

                        <div className="login-input-field-group">
                            <input
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                autoComplete="current-password"
                            />
                        </div>

                        <button
                            type="submit"
                            className="login-submit-button"
                            disabled={loading}
                        >
                            {loading ? "Verifying..." : "Login to Dashboard"}
                        </button>
                    </form>
                </div>

                <div className="login-footer-links">
                    <a href="/">← Back to Website</a>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
